<template>
  <div class="d-flex align-items-center py-2">
    <div>
      <img
        v-if="avatar"
        class="img-fluid rounded-circle mr-2"
        style="width: 24px; height: 24px; object-fit: cover;"
        :src="avatar">
      <b-avatar 
        v-else
        class="mr-2 my-1"
        size="24px"
        :text="name | initial" />
    </div>
    <div class="member__content">
      <p class="member__name mr-2">
        {{ name }}
      </p>
    </div>
    <div
      v-if="group"
      class="mr-2"
      style="font-size: 12px;">
      ({{ group }})
    </div>
    <div
      v-if="position"
      style="font-size: 12px;">
      {{ position }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    avatar: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: ''
    },
    group: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';
</style>